import Vue, { DirectiveOptions } from 'vue'

const directive: DirectiveOptions = {
  inserted: (el, binding, vnode) => {
    const $ref = binding.value !== undefined
      ? vnode.context?.$refs[binding.value]
      : undefined

    el.addEventListener('keydown', (ev: KeyboardEvent) => {
      // We also allow child elements to target this handler
      if (ev.key !== 'Enter' && ev.key !== 'Tab') {
        return
      }

      try {
        if ($ref !== undefined && $ref !== null) {
          (<HTMLElement>$ref)?.focus()
        } else {
          const target = ev.target as HTMLElement

          const form = target.closest('form')
          const formControls = form?.querySelectorAll('input, select, textarea, button')

          if (formControls === undefined) {
            return
          }

          let idx = 0
          for (; idx < formControls.length ?? 0; idx += 1) {
            if (formControls[idx] === ev.target) {
              idx += 1
              break
            }
          }

          if (idx >= formControls.length) {
            return
          }

          (formControls[idx] as HTMLElement).focus()
        }

        ev.preventDefault()
        return false
      } catch (ex) {
        // Just do nothing if we can't refocus, it's not a big deal
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(ex)
        }
      }
    })
  }
}

// Name is a bit misleading as we're also using the same feature for TAB for now, which
// might change in the future as it's not really required to handle that one
Vue.directive('focus-next-on-enter', directive)
